import { useState } from "react";
import { avatarOf } from "../../lib/titleImage";

export { avatarOf };

/** Ad ve soyadın baş harfleri ("AK"); ikisi de yoksa "?". */
export function initialsOf(person) {
  const a = String(person?.name || "").trim()[0] || "";
  const b = String(person?.surname || "").trim()[0] || "";
  return (a + b || "?").toLocaleUpperCase("tr-TR");
}

/**
 * Rozetin altındaki ad: profil resmi seçtiyse o ünvanın adı (avatar.name),
 * seçmediyse kişinin en yüksek ünvanı (title.name). İkisi de yoksa null.
 */
export function avatarCaption(person) {
  const avatar = avatarOf(person);
  return (avatar && avatar.name) || person?.title?.name || null;
}

/**
 * Kişi satırlarının solundaki yuvarlak: seçilmiş ünvan rozeti varsa resmi,
 * yoksa (eski veri, seçim yok, resim yüklenemedi) baş harfler. Altında
 * avatarCaption küçük, soluk ve tek satır yazılır; showName={false} ile
 * kapatılır. Sütun sabit genişlikte, satırlar hizalı kalır.
 */
export default function UserAvatar({ person, size = 36, className = "", showName = true }) {
  const [broken, setBroken] = useState(null);
  const avatar = avatarOf(person);
  const showImage = avatar && broken !== avatar.src;
  const box = { width: size, height: size };
  const caption = showName ? avatarCaption(person) : null;
  const columnWidth = Math.max(size + 20, 56);

  const visual = showImage ? (
    <span data-avatar="image" className="inline-flex items-center justify-center shrink-0" style={box}>
      <img
        src={avatar.src}
        alt=""
        aria-hidden
        width={size}
        height={size}
        loading="lazy"
        draggable={false}
        onError={() => setBroken(avatar.src)}
        className="block w-full h-full object-contain select-none"
      />
    </span>
  ) : (
    <span
      data-avatar="initials"
      aria-hidden
      className="inline-flex items-center justify-center rounded-full shrink-0 font-medium bg-terakkiBrandCloud text-terakkiPrimaryDark dark:bg-white/10 dark:text-white"
      style={{ ...box, fontSize: Math.max(10, Math.round(size * 0.36)) }}
    >
      {initialsOf(person)}
    </span>
  );

  if (!showName) {
    return <span className={`inline-flex shrink-0 ${className}`}>{visual}</span>;
  }
  return (
    <span
      className={`inline-flex flex-col items-center shrink-0 gap-0.5 ${className}`}
      style={{ width: columnWidth }}
    >
      {visual}
      {caption ? (
        <span
          data-avatar-name
          title={caption}
          className="block w-full text-center text-[10px] leading-3 truncate text-terakkiNeutral dark:text-white/60"
        >
          {caption}
        </span>
      ) : null}
    </span>
  );
}
